module.exports = __webpack_public_path__ + "img/deactivate.8b2bed2d.svg";